var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12313",
    "data-name": "Group 12313",
    transform: "translate(-16 -265)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_869",
    "data-name": "Ellipse 869",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(16 265)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "feedback_1_",
    "data-name": "feedback (1)",
    transform: "translate(22.024 270.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M313.071,1.358,312.323.61a.374.374,0,0,0-.528,0h0L307.309,5.1a.374.374,0,0,0-.11.264v.748a.374.374,0,0,0,.374.374h.748a.374.374,0,0,0,.264-.109l4.486-4.486a.374.374,0,0,0,0-.528Zm0,0",
    transform: "translate(-298.228)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M10.093,56.933H9.345a1.123,1.123,0,0,1-1.122-1.121v-.748a1.115,1.115,0,0,1,.329-.793L11.124,51.7H1.869A1.871,1.871,0,0,0,0,53.568V60.3a1.871,1.871,0,0,0,1.869,1.869H5.233v1.869a.374.374,0,0,0,.6.3l2.891-2.168h3.613A1.871,1.871,0,0,0,14.2,60.3V53.285L10.886,56.6A1.114,1.114,0,0,1,10.093,56.933Zm-7.476-2.99H6.355a.374.374,0,0,1,0,.748H2.617a.374.374,0,1,1,0-.748Zm0,2.243H6.355a.374.374,0,0,1,0,.748H2.617a.374.374,0,1,1,0-.748ZM11.962,58.8a.374.374,0,0,1-.374.374H2.617a.374.374,0,1,1,0-.748h8.972A.374.374,0,0,1,11.962,58.8Zm0,0",
    transform: "translate(0 -49.704)",
    fill: "#ed8b00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon_feedback.be615ba23dae165d1d2712f5df0a4c46.svg";
export { ForwardRef as ReactComponent };